import styled, { css } from 'styled-components';

export const LoadingWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    height: -webkit-fill-available;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
    }
  `};
`;

export const LoadingPanel = styled.div`
  ${({ theme }) => css`
    background-size: cover;
    display: flex;
    justify-content: center;
    max-width: 50%;
    overflow: hidden;
    position: relative;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 100%;
      height: 50%;
    }
  `};
`;

export const LoadingImage = styled.img`
  object-fit: cover;
  object-position: right top;
  user-select: none;
  -webkit-user-drag: none;
  width: 100%;
  z-index: 1;
`;

export const LoadingProgressContainer = styled.div`
  ${({ theme }) => css`
    align-items: center;
    align-self: center;
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    margin-bottom: 64px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin-bottom: 0;
      padding: 32px;
      width: -webkit-fill-available;
    }
  `};
`;

export const TextWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 32px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin-bottom: 20px;
    }
  `};
`;

export const LoadingTitle = styled.h3`
  ${({ theme, $isTransitioning }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    text-align: center;
    transition: .1s ease-in-out;
    opacity: ${$isTransitioning ? 0 : 1};

    @media (min-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }

    @media (min-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.md};
    }
    
    @media (min-width: ${theme.v2.breakpoints.lg}) {
      font-size: 28px;
    }
  `};
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  max-width: 440px;
`;
